import { FileType } from 'src/dataFactory/depositionFactory';
import { FilePreDownloadPayload, filesTypes } from './types';

const setUploadFile = (data: { files: any[]; id: any; type: FileType }) => ({
  type: filesTypes.SET_UPLOAD_FILE,
  payload: data,
});

const resetUploadFile = () => ({
  type: filesTypes.RESET_UPLOAD_FILE,
});

const setUploadProgress = (payload: { id: any; progress: any }) => ({
  type: filesTypes.SET_UPLOAD_PROGRESS,
  payload,
});

const successUploadFile = (id: any) => ({
  type: filesTypes.SUCCESS_UPLOAD_FILE,
  payload: id,
});

const failureUploadFile = (payload: { id: any; error: string }) => ({
  type: filesTypes.FAILURE_UPLOAD_FILE,
  payload: payload,
});

const uploadFile = (file: any) => ({
  type: filesTypes.UPLOAD_SINGLE_FILE,
  file: file,
});

const uploadFiles = (files: any[]) => ({
  type: filesTypes.UPLOAD_FILES,
  files: files,
});

const setUploadDone = (isDone: boolean) => ({
  type: filesTypes.SET_UPLOAD_FILE_STATUS,
  payload: isDone,
});

const downloadFiles = (files: FilePreDownloadPayload[]) => ({
  type: filesTypes.DOWNLOAD_FILES,
  files: files,
});

const prepareDownload = (
  payload: FilePreDownloadPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: filesTypes.PREPRARE_DOWNLOAD,
  payload,
  onSuccess,
  onError,
});

export {
  setUploadFile,
  resetUploadFile,
  setUploadProgress,
  successUploadFile,
  failureUploadFile,
  uploadFile,
  uploadFiles,
  setUploadDone,
  downloadFiles,
  prepareDownload,
};
